import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfScreentimeScoreService } from '../../../core/application/services/scores/get-self-screentime-score.service';
import { SelfScreentimeScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-screentime-score.aggregate-root';
import { GetSelfAllScoresRequestDto } from '../../dtos/scores/self-get-all-scores.request.dto';

export class GetSelfScreentimeScoreQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfScreentimeScoreService
  ) {}
  async execute(
    props: GetSelfAllScoresRequestDto
  ): Promise<SelfScreentimeScoreAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
